import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "customDates"];

  connect() {
    this.toggle();
  }

  toggle() {
    const isCustom = this.selectTarget.value === "custom";

    if (isCustom) {
      this.customDatesTarget.classList.remove("hidden");
    } else {
      this.customDatesTarget.classList.add("hidden");
    }
  }

  submitUnlessCustom() {
    if (this.selectTarget.value === "custom") return;

    this.selectTarget.form?.requestSubmit();
  }
}
